<template>
  <div id="app">
    <!--<p>{{env}}</p>-->
  </div>
</template>

<script>
export default {
  props: ["message"],
  data(){return{
    env: process.env.RAILS_ENV
  }}
}
</script>

<style scoped>
</style>
